<template>
  <div class="talentList ptb15 borderBeee" @click="detailsClick">
    <div>
      <span class="mr20">{{ item.name }}</span>
      <span v-for="(item,index) in item.talentsCitys" :key="index">
        {{ item.name }},
        <!--        <span v-if="item.talentsCitys && (index + 1 < item.talentsCitys.length)">,</span>-->
      </span>
    </div>
    <div class="mtb5">
      <b>업종：</b>
      <span v-for="(item,index) in item.talentsTypes" :key="index">
        {{ item.name }},
        <!--        <span v-if="item.talentsTypes && (index + 1 < item.talentsTypes.length)">,</span>-->
      </span>
      <span class="mlr20"><b>근무경력：</b>{{ item.exp }}</span>
      <span>일당：{{ item.money }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Talent-list",
  props: {
    item: {
      type: Object,
      default: () => {

      }
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    detailsClick() {
      this.$emit('detailsClick', this.item)
    }
  }
}
</script>
<style scoped lang="scss">
.talentList {
  cursor: pointer;

  &:hover {
    background-color: #ffe5e5;
  }
}
</style>
